import { useQuery, useQueryClient } from '@tanstack/react-query';
import { getMe, logout as apiLogout } from '../../lib/api';

/** 로그인 상태 훅 — user가 null이면 비회원 (비회원도 전 기능 사용 가능) */
export function useMe() {
  const q = useQuery({
    queryKey: ['me'],
    queryFn: getMe,
    staleTime: 60_000,
    retry: false,
  });
  return { me: q.data?.user ?? null, isLoading: q.isLoading };
}

export function useLogout() {
  const qc = useQueryClient();
  return async () => {
    await apiLogout();
    await qc.invalidateQueries({ queryKey: ['me'] });
    await qc.invalidateQueries({ queryKey: ['readings'] });
  };
}
